import { Injectable } from "@angular/core";
import { ToolbarAction, ToolbarOptions } from "@cotecna/shell";
import {
  REPORT_ISSUE_ACTION_ICON,
  REPORT_ISSUE_ACTION_LABEL,
  REPORT_ISSUE_ACTION_NAME,
} from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class ToolbarOptionsHelper {
  private _toolbarOptions: ToolbarOptions = {
    showMenuButton: false,
    showBackButton: true,
    showCloseButton: false,
    title: "",
    mainActions: [],
    moreActions: [],
  };

  public get toolbarOptions(): ToolbarOptions {
    return this._toolbarOptions;
  }

  constructor() {}

  public setBackFunction(actionFunction: () => void) {
    this._toolbarOptions.backFunction = actionFunction;
  }

  public setActions(actions: ToolbarAction[]): void {
    this._toolbarOptions.mainActions = actions;
  }

  public addAction(action: ToolbarAction): void {
    this._toolbarOptions.mainActions.push(action);
  }

  public setTitle(title: string): void {
    this._toolbarOptions.title = title;
  }

  public getCurrentActions(): ToolbarAction[] {
    return this._toolbarOptions.mainActions;
  }

  public clearMainActions(): void {
    this._toolbarOptions.mainActions = [];
  }

  public clearTitle(): void {
    this._toolbarOptions.title = "";
  }

  public clear(): void {
    this._toolbarOptions.title = "";
    this._toolbarOptions.mainActions = [];
  }

  public tryAddReportIssueAction(): void {
    if (
      !this._toolbarOptions.mainActions.some(
        (x) => x.name === REPORT_ISSUE_ACTION_NAME,
      )
    )
      this._toolbarOptions.mainActions.push({
        name: REPORT_ISSUE_ACTION_NAME,
        label: REPORT_ISSUE_ACTION_LABEL,
        icon: REPORT_ISSUE_ACTION_ICON,
      });
  }
}
